import React from 'react';
import PropTypes from 'prop-types';
import AdCaller from 'helpers/ads/adCaller';
// import smoothScroll from 'smoothscroll';
// import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
// import LoadableComponentLoader from '../../common/LoadableComponentLoader/LoadableComponentLoader';
import s from './StickyFooterWidgets.scss';
// import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

const StickyFooterWidgets = props => {
  const {
    footerData = {},
    frmapp,
    footerWithOnlyFbn,
    // hideBackToTop,
    hideFbn,
    hideAds,
    fbnAdCodeObject,
  } = props;

  // const backtoTopClick = () => {
  //   analyticsWrapper('ga4', {
  //     event: 'user_click',
  //     type: 'move_to_top',
  //     category: 'floating_cta',
  //   });
  //   const data = {
  //     gaAction: 'click',
  //     gaLabel: window.location.href,
  //     gaCategory: 'move_to_top',
  //   };
  //   sendGaThroughProps({
  //     data,
  //   });
  //   smoothScroll(0, 1000);
  // };

  const getBOComponent = () => {
    let retComp = null;
    if (!hideAds && !hideFbn && typeof fbnAdCodeObject === 'object') {
      const adComp = (
        <AdCaller
          data={{ name: 'bottomOverlay', ...fbnAdCodeObject }}
          deviceType="mobile"
          className={`${s.fbn_ad} phShimmerFBN fixed_elements_on_page`}
          immediateLoad
        />
      );
      retComp = adComp;
    }
    return retComp;
  };

  if (footerData) {
    if (!hideAds && !hideFbn && (frmapp || footerWithOnlyFbn)) {
      return <div className={s.fbn_ad_container}>{getBOComponent()}</div>;
    }
    if (hideAds && !hideFbn && frmapp) {
      return null;
    }
  }

  return (
    <>
      {/* {!hideBackToTop && (
        <LoadableComponentLoader
          loadOnScroll
          loadableComponentName="StickyDiv"
          stickyClass={s.sticky}
          offsetFromTop={0}
          aboveFooter
          stickyFromTopStaticHeight={1000}
        >
          <button
            type="button"
            aria-label="back to top"
            className={`${s.backtotop} podcastBackButton`}
            onClick={() => backtoTopClick()}
          />
        </LoadableComponentLoader>
      )} */}

      {getBOComponent()}
    </>
  );
};

StickyFooterWidgets.propTypes = {
  footerData: PropTypes.shape({}).isRequired,
  fbnAdCodeObject: PropTypes.shape({}),
  frmapp: PropTypes.bool,
  footerWithOnlyFbn: PropTypes.bool,
  // hideBackToTop: PropTypes.bool,
  hideFbn: PropTypes.bool,
  hideAds: PropTypes.bool,
};
StickyFooterWidgets.defaultProps = {
  fbnAdCodeObject: undefined,
  frmapp: false,
  footerWithOnlyFbn: false,
  // hideBackToTop: false,
  hideFbn: false,
  hideAds: false,
};

export default StickyFooterWidgets;
